module.exports = __webpack_public_path__ + "0f0077c07342ac035570852d4396986f.png";